import { Button } from 'components/ui/button'

import {
  getManualPaymentsQueryParams,
  getRequiredPaymentsDefaultQueryParams,
} from './preconfiguredQueryParams'
import { useRequiredPaymentsContext } from './RequiredPaymentsContext'

const PreConfiguredQueryLoader = () => {
  const { setQueryParams, automatedCarriers } = useRequiredPaymentsContext()

  const handleResetToDefault = () => setQueryParams(getRequiredPaymentsDefaultQueryParams())
  const handleManualPaymentsQuery = () => setQueryParams(getManualPaymentsQueryParams({ automatedCarriers }))

  return (
    <div className='space-y-4'>
      <div className='flex gap-2'>
        <Button variant='outline' onClick={handleResetToDefault}>
          Reset
        </Button>
        <Button variant='outline' onClick={handleManualPaymentsQuery}>
          Manual Payments
        </Button>
      </div>
    </div>
  )
}

export default PreConfiguredQueryLoader
